import { render } from "./NotFound.vue?vue&type=template&id=1ace4c5a"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dwiki\\learn-vue\\vue-cli\\practice\\coach-vue\\coach-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__